 
import { VKVideoPlaylistContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import { VkVideoPlayList } from "src/libs/useful/vkVideoButton"

/* Protopia Ecosystem component */  
const VKVideoPlayListPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: VKVideoPlaylistContent  = ( props.primitive || {} ) as VKVideoPlaylistContent
    return !!primitive.items?.length
        ?
        <VkVideoPlayList {...primitive } />
        :
        <></>
}
export default VKVideoPlayListPrimitive